import { Component } from "react";
import { graphql } from "gatsby";
import { SeparateJetpassBooking } from "@parksandresorts/core";

export default class SeparateJetpassBookingBlock extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <section className="block block--max-width-narrow block--padded" data-contentful-id={this.props.contentful_id}>
        <SeparateJetpassBooking
          product={this.props.jetpassProduct}
          showOnlyToday={this.props.showOnlyToday}
          labels={{ heading: this.props.heading, paragraph: this.props.paragraph }}
        />
      </section>
    );
  }
}

export const fragmentShowBookingBlock = graphql`
  fragment SeparateJetpassBookingBlock on ContentfulSeparateJetpassBookingBlock {
    contentful_id
    id
    heading
    paragraph {
      raw
    }
    jetpassProduct {
      ...ProductBlock
    }
    showOnlyToday
  }
`;
